import md, { marked } from "marked";
import React from "react";
import ReactHtmlParser from "react-html-parser";

import { Maybe } from "../../types/thecookies";
import DoNotMountComponent from "../DoNotMountComponent/DoNotMountComponent";
import { transformLinks } from "./utils/transform-link";

interface MarkdownToHtmlProps {
  markdown: Maybe<string>;
  settings?: md.MarkedOptions;
  renderer?: md.Renderer;
  props?: object;
  className?: string;
}

const Markdown: React.FC<MarkdownToHtmlProps> = ({ markdown, renderer, props, className }) => {
  if (!markdown) return <DoNotMountComponent sms={"Markdown necesita minimo un string"} log={markdown} />;
  renderer = renderer || new marked.Renderer();
  // esto es un ejemplo de como se puede modificar el renderer
  // const renderer = new marked.Renderer();
  // renderer.strong = (text) => {
  //   return `<strong class="text">${text}</strong>`;
  // };
  // renderer.paragraph = (text) => {
  //   return `<p class="text">${text}</p>`;
  // };

  marked.setOptions({ renderer });
  const html = marked(markdown);
  return <div className={`${className || "md"}`} {...props}>{ReactHtmlParser(html, { transform: transformLinks })}</div>;

};

export default Markdown;
